export var QuestionAcceptedState;
(function (QuestionAcceptedState) {
    QuestionAcceptedState[QuestionAcceptedState["UserSubmitted"] = 0] = "UserSubmitted";
    QuestionAcceptedState[QuestionAcceptedState["Online"] = 1] = "Online";
    QuestionAcceptedState[QuestionAcceptedState["Private"] = 2] = "Private";
    QuestionAcceptedState[QuestionAcceptedState["DeleteIntention"] = 3] = "DeleteIntention";
    QuestionAcceptedState[QuestionAcceptedState["WillDeleteSoon"] = 4] = "WillDeleteSoon";
})(QuestionAcceptedState || (QuestionAcceptedState = {}));
export var EntityChangeOperation;
(function (EntityChangeOperation) {
    EntityChangeOperation["Create"] = "create";
    EntityChangeOperation["Update"] = "update";
    EntityChangeOperation["Delete"] = "delete";
})(EntityChangeOperation || (EntityChangeOperation = {}));
export var BasicOptionCheckState;
(function (BasicOptionCheckState) {
    BasicOptionCheckState["Default"] = "default";
    BasicOptionCheckState["Correct"] = "correct";
    BasicOptionCheckState["Wrong"] = "wrong";
})(BasicOptionCheckState || (BasicOptionCheckState = {}));
export var ChoiceOptionState;
(function (ChoiceOptionState) {
    ChoiceOptionState["Default"] = "default";
    ChoiceOptionState["CorrectPending"] = "correctPending";
    ChoiceOptionState["CorrectDone"] = "correctDone";
    ChoiceOptionState["ShouldHaveBeenSelected"] = "shouldHaveBeenSelected";
    ChoiceOptionState["Wrong"] = "wrong";
})(ChoiceOptionState || (ChoiceOptionState = {}));
export var FunnelType;
(function (FunnelType) {
    FunnelType["Standard"] = "default";
    FunnelType["Succession"] = "succession";
})(FunnelType || (FunnelType = {}));
export var MannerType;
(function (MannerType) {
    MannerType["HearWord"] = "hearWord";
    MannerType["MannerPile"] = "hearWordSequence";
    MannerType["HearAnything"] = "hearAnything";
    MannerType["AutoExpire"] = "expire";
})(MannerType || (MannerType = {}));
export var MannerTypeLabels;
(function (MannerTypeLabels) {
    MannerTypeLabels["hearWord"] = "Spracheingabe enth\u00E4lt Wort";
    MannerTypeLabels["hearWordSequence"] = "Spracheingabe enth\u00E4lt Wortsequenz";
    MannerTypeLabels["hearAnything"] = "Spracheingabe enth\u00E4lt irgendetwas";
    MannerTypeLabels["expire"] = "Zeit l\u00E4uft ab";
})(MannerTypeLabels || (MannerTypeLabels = {}));
export var ConductType;
(function (ConductType) {
    ConductType["SetQuestionCorrect"] = "setQuestionCorrect";
    ConductType["SetQuestionWrong"] = "setQuestionWrong";
    ConductType["PlayMedia"] = "playMedia";
    ConductType["SetAnswerMark"] = "setAnswerMark";
})(ConductType || (ConductType = {}));
export var ConductTypeLabels;
(function (ConductTypeLabels) {
    ConductTypeLabels["setQuestionCorrect"] = "Frage als korrekt werten";
    ConductTypeLabels["setQuestionWrong"] = "Frage als falsch werten";
    ConductTypeLabels["playMedia"] = "Audio/Video abspielen";
    ConductTypeLabels["setAnswerMark"] = "Antwortmarke setzen";
})(ConductTypeLabels || (ConductTypeLabels = {}));
export var QuestionPassStateId;
(function (QuestionPassStateId) {
    QuestionPassStateId["New"] = "new";
    QuestionPassStateId["Wrong"] = "wrong";
    QuestionPassStateId["PartialCorrect"] = "partialcorrect";
    QuestionPassStateId["Blocked"] = "blocked";
    QuestionPassStateId["Skipped"] = "skipped";
    QuestionPassStateId["Passed"] = "passed";
    QuestionPassStateId["CorrectAfterWrong"] = "correctafterwrong";
    QuestionPassStateId["Passed2"] = "passed2";
    QuestionPassStateId["Passed3"] = "passed3";
    QuestionPassStateId["Phase1"] = "phase1";
    QuestionPassStateId["Phase2"] = "phase2";
    QuestionPassStateId["Phase3"] = "phase3";
    QuestionPassStateId["Phase4"] = "phase4";
})(QuestionPassStateId || (QuestionPassStateId = {}));
export var AudioVisualization;
(function (AudioVisualization) {
    AudioVisualization["SpeakerIcon"] = "speaker";
})(AudioVisualization || (AudioVisualization = {}));
export var LevelAccess;
(function (LevelAccess) {
    LevelAccess["Free"] = "free";
    LevelAccess["Premium"] = "premium";
})(LevelAccess || (LevelAccess = {}));
export var QuestionAnswerState;
(function (QuestionAnswerState) {
    QuestionAnswerState["Preload"] = "preload";
    QuestionAnswerState["Answering"] = "answering";
    QuestionAnswerState["Feedback"] = "feedback";
    QuestionAnswerState["Continue"] = "continue";
    QuestionAnswerState["History"] = "history";
    QuestionAnswerState["Editing"] = "editing";
})(QuestionAnswerState || (QuestionAnswerState = {}));
export var AppearState;
(function (AppearState) {
    AppearState["Appearing"] = "appearing";
    AppearState["Visible"] = "visible";
    AppearState["Disappearing"] = "disappearing";
    AppearState["Hidden"] = "hidden";
})(AppearState || (AppearState = {}));
export var QuestionTypeName;
(function (QuestionTypeName) {
    QuestionTypeName["MultipleChoice"] = "MultipleChoice";
    QuestionTypeName["CorrectWrong"] = "CorrectWrong";
    QuestionTypeName["KnowAWord"] = "KnowAWord";
    QuestionTypeName["Associate"] = "Associate";
    QuestionTypeName["MemorizePoints"] = "MemorizePoints";
    QuestionTypeName["ThinkAndReveal"] = "ThinkAndReveal";
    QuestionTypeName["Vocabulary"] = "Vocabulary";
    QuestionTypeName["Read"] = "Read";
    QuestionTypeName["Talk"] = "Talk";
    QuestionTypeName["OrderedChoice"] = "OrderedChoice";
    QuestionTypeName["Intro"] = "Intro";
    QuestionTypeName["CycleEnd"] = "CycleEnd";
    QuestionTypeName["Sortable"] = "Sortable";
    QuestionTypeName["MultiSelect"] = "MultiSelect";
})(QuestionTypeName || (QuestionTypeName = {}));
export var MediaLabel;
(function (MediaLabel) {
    MediaLabel["None"] = "";
    MediaLabel["local"] = "local";
    MediaLabel["questionpart"] = "questionpart";
    MediaLabel["questionVideo"] = "questionVideo";
    MediaLabel["questionAudio"] = "questionAudio";
    MediaLabel["optionSelected"] = "optionSelected";
    MediaLabel["optionHover"] = "optionHover";
    MediaLabel["questionwrong"] = "questionwrong";
    MediaLabel["questioncorrect"] = "questioncorrect";
    MediaLabel["questioncomplete"] = "questioncomplete";
    MediaLabel["questionCompletlyWrong"] = "questionCompletlyWrong";
    MediaLabel["questionPartiallyWrong"] = "questionPartiallyWrong";
    MediaLabel["questionClose"] = "questionClose";
    MediaLabel["correctStep"] = "correctStep";
    MediaLabel["correctComplete"] = "correctComplete";
    MediaLabel["wrongStep"] = "wrongStep";
    MediaLabel["wrongComplete"] = "wrongComplete";
    MediaLabel["cycleBegin"] = "cycleBegin";
    MediaLabel["cycleEnd"] = "cycleEnd";
    MediaLabel["associationWrong"] = "associationWrong";
    MediaLabel["associationCorrect"] = "associationCorrect";
    MediaLabel["associationComplete"] = "associationComplete";
    MediaLabel["enforcementTip"] = "enforcementTip";
    MediaLabel["enforcementPush"] = "enforcementPush";
    MediaLabel["executeManner"] = "executeManner";
    MediaLabel["backgroundRun"] = "backgroundRun";
    MediaLabel["backgroundComplete"] = "backgroundComplete";
    MediaLabel["backgroundCorrect"] = "backgroundCorrect";
    MediaLabel["backgroundWrong"] = "backgroundWrong";
    MediaLabel["taskActive"] = "taskActive";
    MediaLabel["taskWrong"] = "taskWrong";
    MediaLabel["taskCorrect"] = "taskCorrect";
    MediaLabel["taskComplete"] = "taskComplete";
    MediaLabel["taskWrongTry"] = "taskWrongTry";
    MediaLabel["stepWrongTry"] = "stepWrongTry";
    MediaLabel["stepWrong"] = "stepWrong";
    MediaLabel["stepCorrect"] = "stepCorrect";
    MediaLabel["stepComplete"] = "stepComplete";
})(MediaLabel || (MediaLabel = {}));
export var QuestionScoreFactor;
(function (QuestionScoreFactor) {
    QuestionScoreFactor[QuestionScoreFactor["NotYetShown"] = 60] = "NotYetShown";
    QuestionScoreFactor[QuestionScoreFactor["LeastOftenShown"] = 80] = "LeastOftenShown";
    QuestionScoreFactor[QuestionScoreFactor["BadResults"] = 30] = "BadResults";
    QuestionScoreFactor[QuestionScoreFactor["DidacticalRepetition"] = 30] = "DidacticalRepetition";
    QuestionScoreFactor[QuestionScoreFactor["BestRated"] = 80] = "BestRated";
    QuestionScoreFactor[QuestionScoreFactor["AdaptiveDifficulty"] = 60] = "AdaptiveDifficulty";
    QuestionScoreFactor[QuestionScoreFactor["ProgressiveDifficulty"] = 30] = "ProgressiveDifficulty";
    QuestionScoreFactor[QuestionScoreFactor["AlterQuestionType"] = 30] = "AlterQuestionType";
    QuestionScoreFactor[QuestionScoreFactor["AlterSubtopic"] = 30] = "AlterSubtopic";
    QuestionScoreFactor[QuestionScoreFactor["AlterLayout"] = 60] = "AlterLayout";
    QuestionScoreFactor[QuestionScoreFactor["SkipRate"] = 30] = "SkipRate";
    QuestionScoreFactor[QuestionScoreFactor["ExitRate"] = 30] = "ExitRate";
    QuestionScoreFactor[QuestionScoreFactor["IsNativeInTopic"] = 30] = "IsNativeInTopic";
    QuestionScoreFactor[QuestionScoreFactor["TouchFriendlyQuestionType"] = 150] = "TouchFriendlyQuestionType";
    QuestionScoreFactor[QuestionScoreFactor["LevelSuccession"] = 100] = "LevelSuccession";
})(QuestionScoreFactor || (QuestionScoreFactor = {}));
export var LearnwareInstance;
(function (LearnwareInstance) {
    LearnwareInstance["AbfragerDE"] = "abfrager.de";
    LearnwareInstance["AbfragerAT"] = "abfrager.at";
    LearnwareInstance["AbfragerCH"] = "abfrager.ch";
    LearnwareInstance["AbfragerES"] = "abfrager.es";
})(LearnwareInstance || (LearnwareInstance = {}));
export var AudioRecorderState;
(function (AudioRecorderState) {
    AudioRecorderState["NoUsage"] = "nousage";
    AudioRecorderState["GetReady"] = "getready";
    AudioRecorderState["Recording"] = "recording";
    AudioRecorderState["Finished"] = "finished";
})(AudioRecorderState || (AudioRecorderState = {}));
export var SoundCategory;
(function (SoundCategory) {
    SoundCategory["NotClassified"] = "";
    SoundCategory["AudioRecording"] = "recording";
    SoundCategory["SoundEffect"] = "soundeffect";
})(SoundCategory || (SoundCategory = {}));
export var ImageCategory;
(function (ImageCategory) {
    ImageCategory["NotClassified"] = "";
    ImageCategory["Clipart"] = "clipart";
    ImageCategory["Photo"] = "photo";
    ImageCategory["Illustration"] = "illustration";
})(ImageCategory || (ImageCategory = {}));
export var MediaSourceDatabase;
(function (MediaSourceDatabase) {
    MediaSourceDatabase["Unknown"] = "";
    MediaSourceDatabase["Pixabay"] = "pixabay";
    MediaSourceDatabase["OpenClipart"] = "openclipart";
    MediaSourceDatabase["FreeSound"] = "freesound";
    MediaSourceDatabase["Abfrager"] = "abfrager";
    MediaSourceDatabase["Upload"] = "upload";
    MediaSourceDatabase["None"] = "none";
})(MediaSourceDatabase || (MediaSourceDatabase = {}));
export var EditActorLayerTabs;
(function (EditActorLayerTabs) {
    EditActorLayerTabs["Aspects"] = "aspects";
    EditActorLayerTabs["Structure"] = "structure";
    EditActorLayerTabs["Properties"] = "properties";
})(EditActorLayerTabs || (EditActorLayerTabs = {}));
export var TraitScaleType;
(function (TraitScaleType) {
    TraitScaleType["Ratio"] = "ratio";
    TraitScaleType["Height"] = "height";
    TraitScaleType["Width"] = "width";
})(TraitScaleType || (TraitScaleType = {}));
export var LoadStatus;
(function (LoadStatus) {
    // Loading = 'loading',
    LoadStatus["Loading"] = "load";
    LoadStatus["Ready"] = "ready";
})(LoadStatus || (LoadStatus = {}));
export var PlayStatus;
(function (PlayStatus) {
    // Loading = 'loading',
    PlayStatus["Pending"] = "pending";
    PlayStatus["Go"] = "go";
    PlayStatus["Playing"] = "playing";
    PlayStatus["Paused"] = "paused";
    PlayStatus["Ended"] = "ended";
    PlayStatus["Aborted"] = "aborted";
    PlayStatus["Error"] = "error";
})(PlayStatus || (PlayStatus = {}));
export var ChannelName;
(function (ChannelName) {
    ChannelName["Voice"] = "voice";
    ChannelName["Sound"] = "sound";
    ChannelName["Background"] = "background";
})(ChannelName || (ChannelName = {}));
export var SetAspectValueStrategy;
(function (SetAspectValueStrategy) {
    SetAspectValueStrategy["ActiveButOnlyLocal"] = "current";
})(SetAspectValueStrategy || (SetAspectValueStrategy = {}));
export var SSMLLanguage;
(function (SSMLLanguage) {
    SSMLLanguage["DE"] = "de-de";
    SSMLLanguage["EN_US"] = "en-us";
    SSMLLanguage["EN_GB"] = "en-gb";
    SSMLLanguage["FR"] = "fr-fr";
})(SSMLLanguage || (SSMLLanguage = {}));
export var Scene;
(function (Scene) {
    Scene["Loading"] = "loading";
    Scene["Empty"] = "empty";
    Scene["History"] = "showHistory";
    Scene["CycleEnd"] = "cycleEnd";
    Scene["ShowQuestion"] = "showQuestion";
    Scene["NoMoreQuestions"] = "noMoreQuestions";
    Scene["PreviewQuestion"] = "previewQuestion";
})(Scene || (Scene = {}));
export var SlotCategory;
(function (SlotCategory) {
    SlotCategory["Audio"] = "audio";
    SlotCategory["Speak"] = "speak";
    SlotCategory["Hear"] = "hear";
    SlotCategory["Question"] = "question";
    SlotCategory["Other"] = "other";
})(SlotCategory || (SlotCategory = {}));
export var IsoLanguageCode;
(function (IsoLanguageCode) {
    IsoLanguageCode["de_DE"] = "de_DE";
    // fr_FR = 'fr_FR',
    // en_GB = 'en_GB',
    IsoLanguageCode["de_AT"] = "de_AT";
    IsoLanguageCode["de_CH"] = "de_CH";
    IsoLanguageCode["de_ES"] = "es_ES";
    // en_US = 'en_US'
})(IsoLanguageCode || (IsoLanguageCode = {}));
export var CommentType;
(function (CommentType) {
    CommentType["Comment"] = "comment";
    CommentType["CommentCorrect"] = "commentCorrect";
    CommentType["CommentWrong"] = "commentWrong";
})(CommentType || (CommentType = {}));
export var ScaleType;
(function (ScaleType) {
    ScaleType["None"] = "none";
    ScaleType["Width"] = "width";
    ScaleType["Height"] = "height";
    ScaleType["Ratio"] = "ratio";
})(ScaleType || (ScaleType = {}));
export var CorrectWrongButton;
(function (CorrectWrongButton) {
    CorrectWrongButton[CorrectWrongButton["CorrectWrong"] = 0] = "CorrectWrong";
    CorrectWrongButton[CorrectWrongButton["YesNo"] = 1] = "YesNo";
    CorrectWrongButton[CorrectWrongButton["Custom"] = 2] = "Custom";
})(CorrectWrongButton || (CorrectWrongButton = {}));
export var CorrectWrongValue;
(function (CorrectWrongValue) {
    CorrectWrongValue[CorrectWrongValue["StatementIsCorrect"] = 1] = "StatementIsCorrect";
    CorrectWrongValue[CorrectWrongValue["StatementIsWrong"] = 0] = "StatementIsWrong";
})(CorrectWrongValue || (CorrectWrongValue = {}));
export var MemoryType;
(function (MemoryType) {
    MemoryType["Any"] = "";
    MemoryType["PlayedMedia"] = "mediaplay";
})(MemoryType || (MemoryType = {}));
export var TrackIdent;
(function (TrackIdent) {
    TrackIdent["ShowQuestion"] = "show";
    TrackIdent["ContinueImmediatelyAfterAnswer"] = "immediate";
    TrackIdent["AnswerQuestion"] = "answer";
    TrackIdent["RateQuestion"] = "rateQ";
    TrackIdent["RateTopic"] = "rateT";
    TrackIdent["BlockQuestion"] = "block";
    TrackIdent["SkipQuestion"] = "skip";
})(TrackIdent || (TrackIdent = {}));
export var HideStrategy;
(function (HideStrategy) {
    HideStrategy["ShowAll"] = "";
    HideStrategy["HideCorrectsOfPreviousSteps"] = "step1";
})(HideStrategy || (HideStrategy = {}));
export var KnowledgeLevel;
(function (KnowledgeLevel) {
    KnowledgeLevel[KnowledgeLevel["Intro"] = 1] = "Intro";
    KnowledgeLevel[KnowledgeLevel["Lernen"] = 4] = "Lernen";
    KnowledgeLevel[KnowledgeLevel["Erkennen"] = 7] = "Erkennen";
    KnowledgeLevel[KnowledgeLevel["Ausw\u00E4hlen"] = 10] = "Ausw\u00E4hlen";
    KnowledgeLevel[KnowledgeLevel["Schreiben"] = 13] = "Schreiben";
    KnowledgeLevel[KnowledgeLevel["Abfragen"] = 15] = "Abfragen";
    KnowledgeLevel[KnowledgeLevel["Pruefung"] = 18] = "Pruefung";
    KnowledgeLevel[KnowledgeLevel["Exit"] = 20] = "Exit";
})(KnowledgeLevel || (KnowledgeLevel = {}));
export function enumKeys(obj) {
    return Object.keys(obj).filter((k) => Number.isNaN(+k));
}
export var InputMaskType;
(function (InputMaskType) {
    InputMaskType["Auto"] = "";
    InputMaskType["TimeX_XX"] = "timeX:XX";
    InputMaskType["TimeXX_XX"] = "timeXX:XX";
    InputMaskType["Integer"] = "integer";
    InputMaskType["Decimal"] = "decimal";
    InputMaskType["Decimal1x1"] = "decimal1x1";
    InputMaskType["Decimal1x2"] = "decimal1x2";
    InputMaskType["Addition3x1E2"] = "addition3x1E2";
    InputMaskType["Addition3x1E1"] = "addition3x1E1";
    InputMaskType["Addition3P2P1"] = "addition3P2P1";
    InputMaskType["EuroCent"] = "euroCent";
    InputMaskType["Einheit"] = "einheit";
    InputMaskType["Uhrzeit"] = "uhrzeit";
    /*
    Euro = 'euro',
    Cent = 'cent',
    Milliliter = 'ml',
    Liter = 'l',
    Kilogramm = 'kg',
    Gramm = 'g',
  */
    InputMaskType["NumberPrefixSuffix"] = "numberPrefixSuffix";
    //PlusSymbolInteger = '+Integer',
    //MinusSymbolInteger = '-Integer',
    // AllowNegativeInteger = '+-Integer',
})(InputMaskType || (InputMaskType = {}));
export const CONST_EINHEITEN = ["ct", "€", "ml", "l", "kg", "g", "min", "s", "h"];
export var MeasureType;
(function (MeasureType) {
    MeasureType["BoundingClientRect"] = "rect";
    MeasureType["OffsetToPage"] = "offset";
})(MeasureType || (MeasureType = {}));
